import React, { useRef } from 'react';
import { useReveal } from '../Components/Fx/useReveal';

const PARAGRAPHS = [
   'Red Sentinel is dedicated to becoming a database chronicling instances of corporate, political and societal misconduct. By collating information from various sources across the internet, we provide a singular platform, accessible to all, that offers insights into instances where influential entities may have misused their power for personal advantage.',
   'Our focus is on significant events that, for various reasons, might not have received the attention they warranted, or went largely unpunished due to the size, power, or influence of the entities involved. Examples include situations akin to the HSBC money laundering incident, revelations like the Paradise and Panama Papers, or underreported tragedies such as the tragic demise of Daphne Caruana Galizia.',
   "It's not uncommon for such pivotal events to be overshadowed by contemporary distractions, allowing them to fade from public memory. Yet, it is essential to recall these occurrences, not only to hold accountable those who evade justice but to maintain a transparent and informed society.",
   "Project Purity seeks to ensure that history does not easily forget. Whether it's a corporation mishandling a nation's data, financial institutions indirectly supporting illicit activities, pharmaceutical firms contributing to drug crises, or influential individuals engaging in financial secrecy, our platform is committed to preserving and highlighting these stories.",
];

const AboutPage = () => {
   const scope = useRef<HTMLDivElement>(null);
   useReveal(scope);

   return (
      <div ref={scope} className="page grid grid-cols-1 gap-10 md:grid-cols-12">
         <div className="md:col-span-3">
            <p className="eyebrow md:sticky md:top-24" data-reveal>
               Manifesto
            </p>
         </div>
         <div className="space-y-10 md:col-span-9 lg:col-span-7">
            <p className="font-display text-3xl leading-snug text-bone md:text-4xl" data-reveal>
               {PARAGRAPHS[0]}
            </p>
            {PARAGRAPHS.slice(1).map((p, i) => (
               <div key={i} className="grid grid-cols-[3rem_1fr] gap-4" data-reveal>
                  <span className="pt-1 font-mono text-xs text-signal">{String(i + 2).padStart(2, '0')}</span>
                  <p className="text-lg leading-relaxed text-bone-muted">{p}</p>
               </div>
            ))}
         </div>
      </div>
   );
};

export default AboutPage;
